import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './screens/Home'
import { Address } from './screens/Address'
import { Settings } from './screens/Settings'

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="address" element={<Address />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  )
}
